export function downloadFile(fileName: string, blobOrURL: Blob | string): void {
  const isBlob = blobOrURL instanceof Blob;

  // Format snake case
  const formattedFileName = fileName
    .replace(/\W+/g, '_')
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toLowerCase()
    .replace(/^_+|_+$/g, '');

  const url = isBlob ? window.URL.createObjectURL(blobOrURL) : blobOrURL;
  const elem = document.createElement('a');
  elem.href = url;
  elem.download = formattedFileName;
  document.body.appendChild(elem);
  elem.click();
  document.body.removeChild(elem);
}
